import { render, staticRenderFns } from "./score-box.vue?vue&type=template&id=81165fa2&scoped=true"
import script from "./score-box.vue?vue&type=script&lang=js"
export * from "./score-box.vue?vue&type=script&lang=js"
import style0 from "./score-box.vue?vue&type=style&index=0&id=81165fa2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81165fa2",
  null
  
)

export default component.exports